// !!! This file has been auto generated by npm scripts
const appInfo = {
  pkgVersion: '1.46.01',
  pkgName: 'viabeez',
  deployBranch: ''
};
export default appInfo;
